import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';

/**
 * Richiede almeno uno dei realm roles indicati in route data['roles'].
 */
export const roleGuard = createAuthGuard<CanActivateFn>(async (route, _state, { authenticated, grantedRoles }) => {
  const requiredRoles = (route.data['roles'] as string[] | undefined) ?? [];
  const hasRole = requiredRoles.length === 0 || requiredRoles.some((role) => grantedRoles.realmRoles.includes(role));
  return authenticated && hasRole ? true : createUrlTreeFromSnapshot(route, ['/forbidden']);
});
